import styles from './share-to-hub.module.scss';
import { Switch } from 'antd';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { isKnowledgeHubSharedEnabled } from 'shared/store/selectors/features.selector';
import { SHARE_HELPDESK_LINK } from 'shared/constants/assets.constants';
import classNames from 'classnames';
import { LearnMore } from '../common/learn-more';

export function ShareToHub({
  name,
  value,
  setFieldValue,
  showHelpdesk = false,
  topBorder = false,
}) {
  const lang = useSelector(getLang('SHARE_TO_HUB'));

  const isSharedEnabled = useSelector(isKnowledgeHubSharedEnabled);
  if (!isSharedEnabled) return null;

  const onChange = checked => {
    setFieldValue(name, checked);
  };

  return (
    <div className={classNames(styles.root, { [styles.topBorder]: topBorder })}>
      <div className={styles.titleLinkWrapper}>
        <h6>{lang.SHARE_COMMUNITY}</h6>
        {showHelpdesk && <LearnMore link={SHARE_HELPDESK_LINK} text={lang.HELPDESK} />}
      </div>
      <div className={styles.switch}>
        <Switch defaultChecked={value} onChange={onChange} aria-label={lang.SHARE_ITEM} />
        <span className={styles.switchLabel}>{lang.SHARE_ITEM}</span>
      </div>
    </div>
  );
}
